import { createAction, props } from "@ngrx/store";
import { User } from "../../models/user";

export const addUserCompanyAct = createAction('addUserCompanyEffect', props<{ id: string, userNew: User }>());
export const addSuccessUserCompanyAct = createAction('addSuccessUserCompanyEffect', props<{ userNew: User }>());

export const setViolationsUserCompanyAct = createAction('setViolationsUserCompanyEffect', props<{ userForm: User, violations: {} }>());

export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );
